// Campus photo for /colleges/bucknell-university: CC BY-SA 4.0, by Dbl228, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ACherry_blossoms_on_academic_quad.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/bucknell-university/; credited under the photo.
const photo = {
    "slug": "bucknell-university",
    "alt": "Cherry trees in bloom along a path on the Academic Quad, with a white cupola beyond, at Bucknell University in Lewisburg, Pennsylvania",
    "src": "/colleges/bucknell-university/campus-1600.webp",
    "srcSmall": "/colleges/bucknell-university/campus-800.webp",
    "srcMid": "/colleges/bucknell-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/bucknell-university/og.jpg",
    "title": "Cherry blossoms on academic quad",
    "author": "Dbl228",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ACherry_blossoms_on_academic_quad.jpg",
    "read": "2026-10-01"
};

export default photo;
